import { useMutation, useQueryClient } from 'react-query';
import queries from '../queries';

// Sender Configuration Actions
const useCreateSenderConfig = (callbacks = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ companyId, data }) => {
      return queries.deploymentTransfer.createSenderConfig.query(companyId, data);
    },
    {
      ...callbacks,
      onSuccess: ({ data }, variables) => {
        queryClient.invalidateQueries([queries.deploymentTransfer.getSenderConfig.key, variables.companyId]);
        queryClient.invalidateQueries([queries.deploymentTransfer.canTransfer.key, variables.companyId]);
        // Invalidate S3 status when S3 migration settings change
        queryClient.invalidateQueries([queries.deploymentTransfer.getS3Status.key, variables.companyId]);
        if (typeof callbacks.onSuccess === 'function') callbacks.onSuccess(data, variables);
      },
    }
  );
};

const useRegenerateSenderApiKey = (callbacks = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ companyId }) => {
      return queries.deploymentTransfer.regenerateSenderApiKey.query(companyId);
    },
    {
      ...callbacks,
      onSuccess: ({ data }, variables) => {
        queryClient.invalidateQueries([queries.deploymentTransfer.getSenderConfig.key, variables.companyId]);
        if (typeof callbacks.onSuccess === 'function') callbacks.onSuccess(data, variables);
      },
    }
  );
};

const useDeleteSenderConfig = (callbacks = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ companyId }) => {
      return queries.deploymentTransfer.deleteSenderConfig.query(companyId);
    },
    {
      ...callbacks,
      onSuccess: ({ data }, variables) => {
        queryClient.invalidateQueries([queries.deploymentTransfer.getSenderConfig.key, variables.companyId]);
        queryClient.invalidateQueries([queries.deploymentTransfer.canTransfer.key, variables.companyId]);
        // Invalidate transfer and S3 status since connection is broken
        queryClient.invalidateQueries([queries.deploymentTransfer.getTransferStatus.key, variables.companyId]);
        queryClient.invalidateQueries([queries.deploymentTransfer.getS3Status.key, variables.companyId]);
        if (typeof callbacks.onSuccess === 'function') callbacks.onSuccess(data, variables);
      },
    }
  );
};

// Receiver Configuration Actions
const useCreateReceiverConfig = (callbacks = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ companyId, data }) => {
      return queries.deploymentTransfer.createReceiverConfig.query(companyId, data);
    },
    {
      ...callbacks,
      onSuccess: ({ data }, variables) => {
        queryClient.invalidateQueries([queries.deploymentTransfer.getReceiverConfig.key, variables.companyId]);
        queryClient.invalidateQueries([queries.deploymentTransfer.canTransfer.key, variables.companyId]);
        if (typeof callbacks.onSuccess === 'function') callbacks.onSuccess(data, variables);
      },
    }
  );
};

const useDeleteReceiverConfig = (callbacks = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ companyId }) => {
      return queries.deploymentTransfer.deleteReceiverConfig.query(companyId);
    },
    {
      ...callbacks,
      onSuccess: ({ data }, variables) => {
        queryClient.invalidateQueries([queries.deploymentTransfer.getReceiverConfig.key, variables.companyId]);
        queryClient.invalidateQueries([queries.deploymentTransfer.canTransfer.key, variables.companyId]);
        // Invalidate transfer and S3 status since connection is broken
        queryClient.invalidateQueries([queries.deploymentTransfer.getTransferStatus.key, variables.companyId]);
        queryClient.invalidateQueries([queries.deploymentTransfer.getS3Status.key, variables.companyId]);
        if (typeof callbacks.onSuccess === 'function') callbacks.onSuccess(data, variables);
      },
    }
  );
};

// Transfer Operations Actions
const useTransferAll = (callbacks = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ companyId }) => {
      return queries.deploymentTransfer.transferAll.query(companyId);
    },
    {
      ...callbacks,
      onSuccess: ({ data }, variables) => {
        queryClient.invalidateQueries([queries.deploymentTransfer.getTransferStatus.key, variables.companyId]);
        if (typeof callbacks.onSuccess === 'function') callbacks.onSuccess(data, variables);
      },
    }
  );
};

// S3 Migration Actions
const useS3Migrate = (callbacks = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ companyId }) => {
      return queries.deploymentTransfer.s3Migrate.query(companyId);
    },
    {
      ...callbacks,
      onSuccess: ({ data }, variables) => {
        queryClient.invalidateQueries([queries.deploymentTransfer.getS3Status.key, variables.companyId]);
        if (typeof callbacks.onSuccess === 'function') callbacks.onSuccess(data, variables);
      },
    }
  );
};

export default {
  useCreateSenderConfig,
  useRegenerateSenderApiKey,
  useDeleteSenderConfig,
  useCreateReceiverConfig,
  useDeleteReceiverConfig,
  useTransferAll,
  useS3Migrate,
};
